module.exports = __webpack_public_path__ + "img/settings.490c338c.svg";